import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { TextField, InputAdornment } from '@material-ui/core';
import classNames from 'classnames';

import './Search.scss';
import { RootState, Dispatch } from '../../../configs/store';
import Icon from '../../Icon/Icon';

function Search({ placeholder, searchHelper, minLength, getSearchResults, handleReset }) {
  const [searchError, setSearchError] = useState(false);
  const [lastSearchValue, setLastSearchValue] = useState('');
  const [searchValue, setSearchValue] = useState('');

  const dispatch = useDispatch<Dispatch>();
  const {
    search,
    isSearching
  } = useSelector((state: RootState) => state.events);

  useEffect(() => {
    if (!isSearching) {
      setSearchValue('');
    }
  }, [isSearching]);

  const handleSearchChange = (e) => {
    const { value } = e.target;

    dispatch.events.changeSearch(value);
    setSearchValue(value);
    setSearchError(value.length < minLength && value.length > 0);
  };

  const handleResetSearch = () => {
    window.scrollTo(0, 0);
    dispatch.events.changeSearch('');
    setSearchValue('');
    setSearchError(false);
    handleReset('');
  };

  const getSearch = async () => {
    window.scrollTo(0, 0);
    if (search.length >= minLength) {
      setLastSearchValue(search);
      getSearchResults(search);
    }
  };

  const handleKeyPress = (e) => {
    if (e.keyCode === 13 && search.length >= minLength) {
      setLastSearchValue(search);
      getSearchResults(search);
    }
  };

  return (
    <TextField
      type="text"
      className={
        classNames({
          'search__input': true,
          'search__input--error': searchError
        })
      }
      variant="outlined"
      placeholder={ placeholder }
      helperText={ searchHelper }
      value={ searchValue }
      onChange={ handleSearchChange }
      onKeyDown={ handleKeyPress }
      InputProps={
        {
          endAdornment: (
            <InputAdornment position="end">
              {
                isSearching && lastSearchValue === search ?
                  <Icon icon="searchActive" className="search__icon" onClick={ handleResetSearch } />
                  :
                  <Icon icon="search" className="search__icon" onClick={ getSearch } />
              }
            </InputAdornment>
          )
        }
      }
    />
  );
}

Search.propTypes = {
  placeholder: PropTypes.string,
  searchHelper: PropTypes.string,
  minLength: PropTypes.number,
  isSearching: PropTypes.bool,
  getSearchResults: PropTypes.func,
  handleReset: PropTypes.func,
  history: PropTypes.object,
  changeSearch: PropTypes.func,
  search: PropTypes.string
};

export default Search;
